import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=555ae84d&scoped=true&"
import script from "./AboutMe.vue?vue&type=script&lang=js&"
export * from "./AboutMe.vue?vue&type=script&lang=js&"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=555ae84d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ae84d",
  null
  
)

export default component.exports